module.exports = __webpack_public_path__ + "img/floating_plus.7dc25c78.svg";